<div class="dialog-title-row" fxLayout="row" fxLayoutAlign="space-between center">
  <h2 mat-dialog-title>{{ data.title }}</h2>
  <button mat-icon-button class="close-button" (click)="close()" aria-label="Fechar">
    <mat-icon class="close-icon" color="warn">close</mat-icon>
  </button>
</div>

<div mat-dialog-content>
  <form [formGroup]="contatoForm" (ngSubmit)="save()">
    <div class="form-row">
      <mat-form-field appearance="outline" fxFlex="60">
        <mat-label>Nome</mat-label>
        <input matInput formControlName="nome" required>
        <mat-icon matSuffix>person</mat-icon>
        <mat-error *ngIf="contatoForm.get('nome')?.hasError('required')">
          Nome é obrigatório
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Cargo</mat-label>
        <input matInput formControlName="cargo">
        <mat-icon matSuffix>badge</mat-icon>
      </mat-form-field>
    </div>

    <div class="form-row">
      <mat-form-field appearance="outline">
        <mat-label>Telefone / WhatsApp</mat-label>
        <input matInput formControlName="telefone" type="tel" inputmode="tel" placeholder="(44) 99999-9999">
        <mat-icon matSuffix>smartphone</mat-icon>
        <mat-hint>É por este número que a mensagem recebida no WhatsApp identifica o cliente</mat-hint>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Observação do telefone</mat-label>
        <input matInput formControlName="obsTelefone">
        <mat-icon matSuffix>notes</mat-icon>
      </mat-form-field>
    </div>

    <div class="form-row">
      <mat-form-field appearance="outline">
        <mat-label>E-mail</mat-label>
        <input matInput formControlName="email" type="email">
        <mat-icon matSuffix>mail</mat-icon>
        <mat-error *ngIf="contatoForm.get('email')?.hasError('email')">
          E-mail inválido
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Relação</mat-label>
        <mat-select formControlName="relacao">
          <mat-option *ngFor="let r of relacoes" [value]="r.valor">{{ r.descricao }}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Nascimento</mat-label>
        <input matInput formControlName="dataNasc" [matDatepicker]="dpNasc">
        <mat-datepicker-toggle matSuffix [for]="dpNasc"></mat-datepicker-toggle>
        <mat-datepicker #dpNasc></mat-datepicker>
      </mat-form-field>
    </div>

    <div class="form-actions">
      <button mat-button type="button" (click)="close()">Fechar</button>
      <button mat-raised-button color="primary" type="submit">
        <mat-icon>save</mat-icon>
        Salvar
      </button>
    </div>
  </form>
</div>
